<table class="table table-sm table-striped" *ngFor="let section of model.sections">
    <!-- Only display the header line if it contains something or if we have multiple sections that need a visual separator -->
    <thead *ngIf="section.header.length > 0 && model.sections.length > 1">
        <tr>
            <th class="section-header" colspan="2">{{ section.header }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let entry of section.entries">
            <th class="contract-label">{{ entry.label }}</th>
            <td class="contract-value">{{ entry.value | formatSapValue }}</td>
        </tr>
    </tbody>
</table>
